import { render, staticRenderFns } from "./addManagerUser.vue?vue&type=template&id=16ef5ef2&scoped=true&"
import script from "./addManagerUser.vue?vue&type=script&lang=ts&"
export * from "./addManagerUser.vue?vue&type=script&lang=ts&"
import style0 from "./addManagerUser.vue?vue&type=style&index=0&id=16ef5ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef5ef2",
  null
  
)

export default component.exports